<template>
    <div class="container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-6">
                        <span>Editar plantilla del turno</span>
                    </div>
                    <div class="card-header-action-buttons col-6">
                        <ButtonComponent
                            :buttonText="'Refrescar'"
                            :buttonColor="colors.BLUE_COLOR_BUTTON"
                            :buttonAction="refreshShiftsTemplates"
                        />
                    </div>
                </div>
            </div>
            <div v-if="isLoading" style="padding: 5ch 0;">
                <SpeenComponent  
                    :isAutomatic="true" 
                    :ringWidth="14" 
                    :spinnerSize="15" 
                    :isverticalAligned="true"
                />
            </div>
            <div class="card-body" v-else>
                <template>
                    <b-row>
                        <b-col cols="12" md="12">
                            <b-form-group label="Descripción:" label-for="description-input" :label-cols="4">
                                <b-form-input v-model="shiftTemplate.description" id="description-input" required />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group label="Línea de producción:" label-for="production-line-input" :label-cols="4">
                                <b-form-select class="form-control" v-model="shiftTemplate.production_line_id" :options="productionLines" id="production-line-input" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Día de la semana:" label-for="weekday-input" :label-cols="4">
                                <b-form-input v-model="shiftTemplate.weekday.name" id="weekday-input" disabled />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="6">
                            <b-form-group label="Hora de inicio:" label-for="start-time-input" :label-cols="4">
                                <b-form-input v-model="shiftTemplate.start_time" type="time" id="start-time-input" required />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Hora de fin:" label-for="end-time-input" :label-cols="4">
                                <b-form-input v-model="shiftTemplate.end_time" type="time" id="end-time-input" required />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <hr v-if="canEditShiftTemplate">
                    <div class="d-flex justify-content-end">
                        <ButtonComponent
                            v-if="canEditShiftTemplate"
                            :buttonText="'Guardar'"
                            :buttonColor="colors.GREEN_COLOR_BUTTON"
                            :buttonAction="updateShiftTemplate"
                            />
                    </div>
                </template>
                <hr>
                <div class="shift-stops-templates-header">
                    <div class="row">
                        <div class="shift-stops-templates-header-label col-2">
                            <span>Plantillas de parada</span>
                        </div>
                        <div class="shift-stops-templates-header-pagination col-8">
                            <b-pagination 
                                v-model="currentPage" 
                                :total-rows="stopsTemplates.length" 
                                :per-page="perPage" 
                                aria-controls="stops-templates-index-table" 
                                style="margin: 0"
                                align="center" 
                            />
                        </div>
                        <div class="col-1"></div>
                        <div class="shift-stops-templates-header-action-buttons col-1">
                            <ButtonComponent
                                v-if="canCreateStopTemplate"
                                :buttonText="'Nueva'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="createStopTemplate"
                            />
                        </div>
                    </div>
                </div>
                <hr>
                <template>
                    <b-table 
                        id="stops-templates-index-table" 
                        striped 
                        hover 
                        :items="stopsTemplates" 
                        :fields="fields" 
                        responsive 
                        :per-page="perPage" 
                        :current-page="currentPage"
                        >
                        <template v-slot:cell(actions)="data">
                            <ButtonComponent
                                v-if="data.item && canEditStopTemplate"
                                :buttonText="'Editar'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="() => editStopTemplate(data.item)"
                            />
                            <ButtonComponent
                                v-if="data.item && canDeleteStopTemplate"
                                :buttonText="'Eliminar'"
                                :buttonColor="colors.RED_COLOR_BUTTON"
                                :buttonAction="() => deleteStopsTemplate(data.item.id)"
                            />
                        </template>
                    </b-table>
                </template>
            </div>
        </div>
        <transition name="slide-fade">
            <StopTemplateModal
                v-if="showStopTemplateModal"
                :formDataStopTemplate="formDataStopTemplate"
                :isNewStopTemplate="isNewStopTemplate"
                @form-submitted="refreshShiftsTemplates"
                @close-modal="closeStopTemplateModal"
            />
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="contentMessage"
                :closeModal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../../common/utils';
import SpeenComponent from '../../../common/components/SpeenComponent.vue';
import PermissionConsts from '../../../common/permissions';
import ButtonComponent from '../../../common/components/ButtonComponent.vue';
import Colors from '../../../common/colors';
import ActionConfirmModal from '../../../common/components/modals/ActionConfirmModal.vue';
import StopTemplateModal from '../components/StopTemplateModal.vue';

export default {
    name: 'ShiftsTemplateEdit',
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        StopTemplateModal,
    },
    props: {
        shiftTemplateIdProp: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            shiftTemplate: {},
            stopsTemplates: [],
            productionLines: [],
            formDataStopTemplate: {
                shifts_template_id: this.shiftTemplateIdProp,
                start_time: '',
                end_time: '',
                description: '',
            },
            currentPage: 1,
            perPage: 10,
            isLoading: true,
            showCreateModal: false,
            showEditModal: false,
            colors: Colors,
            showActionConfirmModal: false,
            contentMessage: '',
            methodForProp: null,
            isNewStopTemplate: true,
            showStopTemplateModal: false,
        };
    },
    methods: {
        refreshShiftsTemplates() {
            this.isLoading = true;
            this.getShiftTemplateWithStopsTemplate();
        },
        startingApiCalls() {
            this.getProductionLines();
            this.getShiftTemplateWithStopsTemplate();
        },
        getProductionLines() {
            axios.get('/api/production-line')
                .then(response => {
                    this.productionLines = response.data.map(productionLine => {
                        return {
                            value: productionLine.id,
                            text: productionLine.name
                        };
                    });
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getShiftTemplateWithStopsTemplate() {
            axios.get('/api/shifts-template/' + this.shiftTemplateIdProp + '/stops-templates')
                .then(response => {
                    this.shiftTemplate = response.data;
                    this.stopsTemplates = response.data.stops_templates;
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        createStopTemplate() {
            this.formDataStopTemplate = {
                shifts_template_id: this.shiftTemplateIdProp,
                start_time: '',
                end_time: '',
                description: '',
            };
            this.isNewStopTemplate = true;
            this.showStopTemplateModal = true;
        },
        editStopTemplate(stopTemplate) {
            this.formDataStopTemplate = {
                id: stopTemplate.id,
                shifts_template_id: this.shiftTemplateIdProp,
                start_time: stopTemplate.start_time,
                end_time: stopTemplate.end_time,
                description: stopTemplate.description,
            };
            this.isNewStopTemplate = false;
            this.showStopTemplateModal = true;
        },
        closeStopTemplateModal() {
            this.showStopTemplateModal = false;
        },
        updateShiftTemplate() {
            this.isLoading = true;
            axios.patch(`/api/shifts-template/${this.shiftTemplate.id}`, this.shiftTemplate)
                .then(response => {
                    this.getShiftTemplateWithStopsTemplate();
                    showCustomSuccessSweetAlert('Plantilla de turno actualizada correctamente');
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        deleteStopsTemplate(id) {
            this.contentMessage = `¿Está seguro de que desea eliminar la plantilla de parada?`;
            this.methodForProp = () => {
                this.deleteStopsTemplateConfirmed(id);
            };
            this.openActionConfirmModal();
        },
        deleteStopsTemplateConfirmed(id) {
            axios.delete(`/api/stops-template/${id}`)
                .then(response => {
                    this.getShiftTemplateWithStopsTemplate();
                    showCustomSuccessSweetAlert('Plantilla de parada del turno eliminada correctamente');
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.closeActionConfirmModal();
                });
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed: {
        ...mapGetters(['userPermissions','userHasPermission']),
        canEditShiftTemplate(){
            return this.userHasPermission(PermissionConsts.SHIFTS_TEMPLATE_ADMON_UPDATE);
        },
        canCreateStopTemplate(){
            return this.userHasPermission(PermissionConsts.STOPS_TEMPLATE_STORE);
        },
        canDeleteStopTemplate(){
            return this.userHasPermission(PermissionConsts.STOPS_TEMPLATE_ADMON_DELETE);
        },
        canEditStopTemplate(){
            return this.userHasPermission(PermissionConsts.STOPS_TEMPLATE_ADMON_UPDATE);
        },
        canShowActionColumn(){
            return this.canEditStopTemplate || this.canDeleteStopTemplate;
        },
        fields() {
            let baseFields = [
            { key: 'start_time', label: 'Hora de inicio', sortable: true, thStyle: { width: '29%' }, tdStyle: { width: '29%' } },
            { key: 'end_time', label: 'Hora de fin', sortable: true, thStyle: { width: '29%' }, tdStyle: { width: '29%' } },
            { key: 'description', label: 'Descripción', sortable: true, thStyle: { width: '29%' }, tdStyle: { width: '29%' } },
            ];
            if (this.canShowActionColumn) {
            baseFields.push({ key: 'actions', label: 'Acciones', thStyle: { width: '13%' }, tdStyle: { width: '13%' } });
            }
            return baseFields;
        }
    },
    mounted() {
        this.startingApiCalls();
    },
};
</script>

<style scoped lang="scss">
.shift-stops-templates-header {
    .shift-stops-templates-header-label{
        display: flex;
        align-items: center;
    }
    .shift-stops-templates-header-action-buttons {
        display: flex;
        justify-content: flex-end;
    }
}
</style>